import { render, staticRenderFns } from "./Breath.vue?vue&type=template&id=1c57742b&"
import script from "./Breath.vue?vue&type=script&lang=js&"
export * from "./Breath.vue?vue&type=script&lang=js&"
import style0 from "./Breath.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports